import { createAsyncThunk } from "@reduxjs/toolkit"
import { get, post, put } from "helpers/api_helper"

import {
  ADD_MENU_SETUP,
  GET_ALL_MENU_SETUP,
  UPDATE_MENU_SETUP,
  DELETE_MENU_SETUP,
  MENU_WITHOUT_PAGINATION,
  GET_MENU_SETUP,
  MENU_BY_COUNTRY_AND_BRAND,
} from "helpers/url_helper"

export const addMenuSetup = createAsyncThunk(ADD_MENU_SETUP, async payload => {
  const response = await post(ADD_MENU_SETUP, payload)
  return response
})

export const getMenuSetup = createAsyncThunk(GET_MENU_SETUP, async payload => {
  const response = await get(`${GET_MENU_SETUP}?id=${payload}`)
  return response
})

export const getAllMenuSetup = createAsyncThunk(
  GET_ALL_MENU_SETUP,
  async payload => {
    const response = await post(GET_ALL_MENU_SETUP, payload)
    return response
  }
)

export const updateMenu = createAsyncThunk(UPDATE_MENU_SETUP, async payload => {
  const response = await put(UPDATE_MENU_SETUP, payload)
  return response
})

export const deleteMenu = createAsyncThunk(DELETE_MENU_SETUP, async payload => {
  const response = await put(DELETE_MENU_SETUP, payload)
  return response
})

export const getMenusWithoutPagination = createAsyncThunk(
  MENU_WITHOUT_PAGINATION,
  async params => {
    const response = await get(MENU_WITHOUT_PAGINATION, { params })
    return response
  }
)

export const getMenuByBrandandCountry = createAsyncThunk(
  MENU_BY_COUNTRY_AND_BRAND,
  async payload => {
    const response = await post(MENU_BY_COUNTRY_AND_BRAND, payload)
    return response
  }
)
